import i18next from 'i18next';

i18next.addResources('es', 'home', {
  welcome: 'BIENVENIDOS',
  title: 'Base de datos de proyectos de infraestructura',
  description1: 'Esta es base de datos de proyectos del Observatorio de Infraestructura de América del Sur de la Red de Infraestructura del Consenso de Brasilia.',
  description2: 'Contiene un conjunto de obras de fuerte impacto para el desarrollo socio-económico regional, compuesta por proyectos de transporte y logística que promueven la conectividad física y generan desarrollo económico y social sustentable. Formando así la Cartera de Proyectos del Observatorio, que es actualizada anualmente por los doce países de América del Sur.',
  totalProjects: 'Total proyectos:',
  totalInvestment: 'Total inversión (USD):'
});

i18next.addResources('en', 'home', {
  welcome: 'WELCOME',
  title: 'Infrastructure Projects Database',
  description1: 'This is the project database of the South American Infrastructure Observatory of the Brasilia Consensus Infrastructure Network.',
  description2: 'It contains a set of works with strong impact for regional socio-economic development, composed of transport and logistics projects that promote physical connectivity and generate sustainable economic and social development. Thus forming the Observatory Project Portfolio, which is updated annually by the twelve South American countries.',
  totalProjects: 'Total projects:',
  totalInvestment: 'Total investment (USD):'
});

i18next.addResources('pt', 'home', {
  welcome: 'BEM-VINDOS',
  title: 'Base de dados de projetos de infraestrutura',
  description1: 'Esta é a base de dados de projetos do Observatório de Infraestrutura da América do Sul da Rede de Infraestrutura do Consenso de Brasília.',
  description2: 'Contém um conjunto de obras de forte impacto para o desenvolvimento socioeconômico regional, composta por projetos de transporte e logística que promovem a conectividade física e geram desenvolvimento econômico e social sustentável. Formando assim o Portfólio de Projetos do Observatório, que é atualizado anualmente pelos doze países da América do Sul.',
  totalProjects: 'Total de projetos:',
  totalInvestment: 'Investimento total (USD):'
});
